import { useGlobalContext } from './context'
import { Link } from 'react-router-dom'
//no photo display
const url = 'https://ualr.edu/elearning/files/2020/10/No-Photo-Available.jpg'

const Movies = () => {
  const { movies, isLoading } = useGlobalContext()

  if (isLoading) {
    return <div className='loading'></div>
  }

  return(
    <section className="movies">
      {movies.map((movie)=>{
      const {imdbID:id,Poster,Title,Year,Type} = movie
      return (
      <Link to={`/movies/${id}`} key={id} className="movie"> 
       <article>
         <img src={Poster === 'N/A'? url : Poster} alt={Title} />
         <div className="movie-info">
           <h4 className="title">
             {Title}
           </h4>
           <p>{Year}</p>
           <p>{Type}</p>
         </div>
       </article>
       </Link>)
       })}
      
    </section>
  )

  
}
export default Movies
